import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deletePermisoTipoDePlaca,
  getPermisosDeTipoDePlaca,
  patchPermisoTipoDePlaca,
  postPermisoTipoDePlaca,
} from 'api/catalogos/permisosDeTipoDePlacas';

// eslint-disable-next-line react/prop-types
const permisosDeTipoDePlaca = ({ permission }) => (
  <PlainCRUD
    title="Permisos de tipo de placa"
    permission={permission}
    get={getPermisosDeTipoDePlaca}
    post={postPermisoTipoDePlaca}
    patch={patchPermisoTipoDePlaca}
    delete={deletePermisoTipoDePlaca}
    withoutState
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
      {
        name: 'observaciones',
        label: 'Observaciones',
        type: 'textarea',
        colWidth: 200,
        autoSize: { minRows: 3, maxRows: 4 },
      },
    ]}
  />
);

export default permisosDeTipoDePlaca;
